import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Square.scss';
const Square = ({ size = 35, color = 'black', speed = 1.2, stroke = 5, strokeLength = 0.25, bgOpacity = 0.1, }) => {
    const sizeInt = parseInt(size + '');
    const strokeInt = parseInt(stroke + '');
    const centerPoint = strokeInt / 2;
    const strokeAdjustedSize = Math.max(sizeInt - strokeInt / 2, 0);
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
            '--uib-dash': String(parseFloat(strokeLength + '') * 100),
            '--uib-gap': String(100 - parseFloat(strokeLength + '') * 100),
            '--uib-bg-opacity': bgOpacity + '',
        }, children: _jsxs("svg", { className: styles.inner, viewBox: `0 0 ${size} ${size}`, height: size, width: size, children: [_jsx("rect", { className: styles.track, x: centerPoint, y: centerPoint, fill: "none", strokeWidth: `${stroke}px`, width: strokeAdjustedSize, height: strokeAdjustedSize }), _jsx("rect", { className: styles.car, x: centerPoint, y: centerPoint, fill: "none", strokeWidth: `${stroke}px`, width: strokeAdjustedSize, height: strokeAdjustedSize, pathLength: "100" })] }) }));
};
export default Square;
